import { createSlice } from '@reduxjs/toolkit';
import cookieUtil from 'tradera/utils/cookie';
import {
    WISH_LIST_NOTIFICATION_DISPLAY_COUNT,
    WISH_LIST_NOTIFICATION_HIDDEN
} from 'tradera/constants/cookies';

const slice = createSlice({
    name: 'wishListNudge',
    initialState: { wishListNudgeHidden: false },
    reducers: {
        addDisplayCount: {
            reducer: (state, { payload }) => {
                // eslint-disable-next-line better-mutation/no-mutation
                state.wishListNudgeHidden = payload.wishListNudgeHidden;
            },
            prepare: () => {
                const isHidden =
                    cookieUtil.readCookie(WISH_LIST_NOTIFICATION_HIDDEN) ===
                    'true';
                if (isHidden) return { payload: { wishListNudgeHidden: true } };

                const displayCount =
                    (parseInt(
                        cookieUtil.readCookie(
                            WISH_LIST_NOTIFICATION_DISPLAY_COUNT
                        )
                    ) || 0) + 1;
                if (displayCount > 3) {
                    cookieUtil.createCookie(
                        WISH_LIST_NOTIFICATION_HIDDEN,
                        true,
                        Infinity
                    );
                    cookieUtil.eraseCookie(
                        WISH_LIST_NOTIFICATION_DISPLAY_COUNT
                    );
                    return { payload: { wishListNudgeHidden: true } };
                }

                cookieUtil.createCookie(
                    WISH_LIST_NOTIFICATION_DISPLAY_COUNT,
                    displayCount,
                    Infinity
                );
                return { payload: { wishListNudgeHidden: false } };
            }
        },
        hideWishListNudge: {
            reducer: (state) => {
                // eslint-disable-next-line better-mutation/no-mutation
                state.wishListNudgeHidden = true;
            },
            prepare: () => {
                cookieUtil.createCookie(
                    WISH_LIST_NOTIFICATION_HIDDEN,
                    true,
                    Infinity
                );
                cookieUtil.eraseCookie(WISH_LIST_NOTIFICATION_DISPLAY_COUNT);
                return {};
            }
        }
    }
});

export const { addDisplayCount, hideWishListNudge } = slice.actions;

export const wishListNudge = slice.reducer;
